'use strict';

import ready from './lib/ready';

import {delegate} from './lib/events';
import fd, {mutate} from './lib/promise-fastdom';
import promiseIdle from './lib/promise-idle';
import ToggleArea from './lib/ToggleArea';
import focusElement from './lib/focus-element';
import nodeFromTemplate from './lib/node-from-template';
import {ButtonBehavior} from './lib/ToggleArea_ButtonBehavior';
import FocusJail from './lib/FocusJail';
import BreakpointObserver from './lib/BreakpointObserver';
import promiseRAF from './lib/promise-raf';

ready()
    .then(promiseIdle())
    .then(mutate(function () {
        
        const navMain = document.querySelector('.nav__main');
        if (!navMain) {
            return;
        }

        let nav;
        let tabletPromise, desktopPromise;

        const root = document.documentElement;
        const headnav = document.querySelector('.headnav');
        const header = document.querySelector('.header__inner');
        const button = nodeFromTemplate('nav-toggle-tpl');
        const area = document.getElementById('nav');
        const searchToggle = document.querySelector('.search-toggle');
        const ctas = document.querySelector('.head-ctas');

        // #nav link
        document.addEventListener('click', delegate('a[href="#nav"]', function (e) {
            if (!nav) {
                e.preventDefault();
                focusElement.call(area, true);
            }
        }));

        // to handle scroll-margin
        document.addEventListener('focusin', delegate('.nav', mutate(function () {
            root.classList.add('nav-focused');
        })), {passive: true});
        document.addEventListener('focusout', delegate('.nav', mutate(function () {
            root.classList.remove('nav-focused');
        })), {passive: true});

        document.addEventListener('nav/before-open', mutate(function () {
            root.classList.add('nav-on');
        }), {passive: true});
        document.addEventListener('nav/before-close', mutate(function () {
            root.classList.remove('nav-on');
        }), {passive: true});

        // move ctas between nav and header
        (new BreakpointObserver('tablet')).observe(query => {
            tabletPromise = Promise.resolve(tabletPromise).then(mutate(() => {
                query.matches
                    ? searchToggle.insertAdjacentElement('afterend', ctas)
                    : navMain.insertAdjacentElement('afterend', ctas);
            }));
        });

        // toggle between mobile and desktop navigation
        (new BreakpointObserver('desktop')).observe(query => {
            desktopPromise = Promise.resolve(desktopPromise)
                .then((reset) => typeof reset === 'function' ? reset() : null)
                .then(() => query.matches ? initDesktopMode() : initMobileMode());
        });

        function initDesktopMode() {
            return Promise.resolve()
                .then(mutate(() => {
                    header.insertAdjacentElement('afterbegin', area);
                    root.classList.remove('nav-on');
                }))
                .then(promiseRAF())
                .then(mutate(() => {
                    header.classList.add('ready');
                    return function reset() {
                        fd.mutate(() => header.classList.remove('ready'));
                    };
                }));
        }

        function initMobileMode() {
            const buttonBehavior = new ButtonBehavior(button, {
                closeOnOutsideClick: false,
                jail: new FocusJail([button, area, searchToggle])
            });

            function jailUpdate() {
                buttonBehavior.jail().update();
            }

            return Promise.resolve()
                .then(mutate(function () {
                    headnav.insertAdjacentElement('beforeend', area);
                    searchToggle.insertAdjacentElement('beforebegin', button);
                    nav = new ToggleArea(area, 'nav', [
                        buttonBehavior
                    ]);

                    document.addEventListener('submenu/after-open', jailUpdate);
                    document.addEventListener('submenu/after-close', jailUpdate);

                    return nav.ready();
                }))
                .then(() => function reset() {
                    return nav.destroy().then(function () {
                        button.remove();
                        nav = null;
                        document.removeEventListener('submenu/after-open', jailUpdate);
                        document.removeEventListener('submenu/after-close', jailUpdate);
                    });
                });
        }
    }));